import { render, staticRenderFns } from "./AssignedToCard.vue?vue&type=template&id=344aa57d"
import script from "./AssignedToCard.vue?vue&type=script&lang=js"
export * from "./AssignedToCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports